import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import StatusChip from "../common/StatusChip";
import RowMenu from "../common/RowMenu";

const QuotationTable = ({ quotations, onAction }) => {
  return (
    <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e0e0e0' }}>
      <Table>
        <TableHead sx={{ bgcolor: '#fafafa' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>CREATED</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>CLIENT/COMPANY</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>STRUCTURE</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>TOTAL</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>STATUS</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>ACTION</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {quotations.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell>{row.id}</TableCell>
              <TableCell>{new Date(row.createdAt).toLocaleDateString()}</TableCell>
              <TableCell>
                  <div style={{fontWeight: 'bold'}}>{row.client?.clientName}</div>
                  <div style={{fontSize: '0.8em', color: '#666'}}>{row.client?.clientEmail}</div>
              </TableCell>
              <TableCell>{row.businessStructure?.structure || '-'}</TableCell>
              <TableCell>${row.totals?.grandTotal || 0}</TableCell>
              <TableCell>
                <StatusChip status={row.status} />
              </TableCell>
              <TableCell>
                <RowMenu 
                    actions={[
                        { label: 'Edit / Continue', onClick: () => onAction('edit', row) },
                        { label: 'Download PDF', onClick: () => onAction('download', row) }, 
                        { 
                            label: 'Send Email', 
                            onClick: () => onAction('send', row),
                            disabled: true // Disabled as per req
                        },
                        { label: 'Delete', onClick: () => onAction('delete', row), color: 'error.main' }
                    ]} 
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default QuotationTable;
